import { SOL_MINT } from "@/lib/revive-create/sol-constants";

async function dexScreenerSolUsd() {
  try {
    const res = await fetch(`https://api.dexscreener.com/latest/dex/tokens/${SOL_MINT}`);
    if (!res.ok) return null;
    const json = await res.json();
    const onSol = (json.pairs ?? []).filter((p) => p.chainId === "solana");
    if (!onSol.length) return null;
    onSol.sort((a, b) => (b.liquidity?.usd ?? 0) - (a.liquidity?.usd ?? 0));
    const px = parseFloat(onSol[0]?.priceUsd ?? "");
    if (Number.isFinite(px) && px > 0 && px < 1e6) return px;
  } catch {
    /* */
  }
  return null;
}

async function coingeckoSolUsd() {
  try {
    const res = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd");
    if (!res.ok) return null;
    const json = await res.json();
    const p = json?.solana?.usd;
    if (typeof p === "number" && p > 0) return p;
  } catch {
    /* */
  }
  return null;
}

export async function fetchSolSpotUsd() {
  const must = (p) =>
    p.then((v) => {
      if (v == null || !Number.isFinite(v) || v <= 0) throw new Error("no");
      return v;
    });

  try {
    return await Promise.any([must(dexScreenerSolUsd()), must(coingeckoSolUsd())]);
  } catch {
    return null;
  }
}
